<template>
  <div class="dashboard">
    <div class="row">
      <div class="flex xs12 sm6">
        <BreadCrumb :location="location" :siteNames="siteNames" :gwNames="gwNames" />
      </div>
      <div class="flex xs12 sm6">
        <div class="d-flex justify--end">
          <va-button @click="globalSearch" icon="fa fa-search">
              Search
          </va-button>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="flex xs12 xl4">
        <dashboard-table :location="location" @setListDataSummary="setListDataSummary" />
      </div>
      <div class="flex xs12 lg8">
        <dashboard-info-block :location="location" :summary-data="listDataSummary" />
      </div>
    </div>

    <va-modal v-model="showSearchDialog" :noOutsideDismiss="true" :hideDefaultActions="true" title="Search">
      <DashboardSearch @close="closeSearch" style=" max-width: 90vh;"/>
    </va-modal>

  </div>
</template>

<script>
import DashboardCharts from './DashboardCharts'
import DashboardInfoBlock from './DashboardInfoBlock'
import DashboardTable from './DashboardTable'
import DashboardTabs from './DashboardTabs'
import DashboardMap from './DashboardMap'
import BreadCrumb from '../admin/breadcrumb/BreadCrumb'
import DashboardSearch from './DashboardSearch'

import { getLineChartData } from '../../data/charts/LineChartData'

import hiqapi from '@/hiqapi/hiqapi'

export default {
  name: 'dashboard',
  components: {
    DashboardCharts,
    DashboardInfoBlock,
    DashboardTable,
    DashboardTabs,
    DashboardMap,
    BreadCrumb,
    DashboardSearch,
  },
  watch: {
    $route(to, from) {
      // console.log('WATCH', this.$route.path)
      this.updateLocation(this.$route.path)
    },
  },
  beforeRouteUpdate(to, from, next) {
    console.log('BEFORE ROUTE UPDATE', this.$route.path, to, from)
    next()
  },
  beforeRouteEnter(to, from, next) {
    console.log('BEFOR ROUTE ENTER', to, from)
    next()
  },
  created() {
    // load up the list of sites and (all) gateways for this user for the BreadCrumb. This
    // may be redundant if the user starts at the main list-of-sites page, but is necessary
    // if they load a GW or Inv from a bookmark/link. TODO: Fix this later.
    hiqapi.getcb('/sites', this.setDataSiteNames)
    hiqapi.getcb('/gateways', this.setDataGatewayNames)
    this.updateLocation(this.$route.path)
  },
  data() {
    return {
      lineChartData: getLineChartData(this.$themes),
      listSelectedItem: null,

      // Instead of the "summary" objects making their own requests, the data is returned
      // with another request that is already being made and then given to us (the Dashboard)
      // and then passed via props to those summary objects
      listDataSummary: null,
      location: {
        siteId: null, // non-null for 'gws', 'invs'
        siteTz: null,
        gwSerial: null, // non-null for 'invs'
        listType: null,
        selectedId: null, // value of selecteditem['item_id']
        TYPE_SITES: 'sites',
        TYPE_GWS: 'gws',
        TYPE_INVS: 'invs',
      },

      siteNames: { 238: 'Two Thirty Eight' }, // names of sites, indexed by site_id (for BreadCrumb)
      gwNames: { 1315: 'Thirteen Fifteen' }, // names of GWs, indexed by gw_serial (for BreadCrumb)

      showSearchDialog: false,

    }
  },
  methods: {

    // Called whenever our location (URL) changes so that it can be
    // broken down in to parts (siteId, gwSerial, invSerial) and this
    // info can be propogated to those who care.
    //
    // see BreadCrumb.vue for details on this.location contents
    //
    updateLocation(url) {
      this.location.siteId = null
      this.location.siteTz = null
      this.location.gwSerial = null
      this.location.listType = this.location.TYPE_SITES
      this.location.selectedId = null

      let u = url.split('/')
      if (u.length > 3) {
        this.location.siteId = u[3]

        if (this.location.siteId in this.siteNames) {
          this.location.siteTz = this.siteNames[this.location.siteId]['tz']
        } else {
          this.location.siteTz = null
        }

        this.location.selectedId = u[3] > 0 ? parseInt(u[3]) : null
      }

      if (u.length > 4) {
        this.location.gwSerial = u[4]
        this.location.listType = this.location.TYPE_GWS
        this.location.selectedId = u[4] > 0 ? parseInt(u[4]) : null
      }

      if (u.length > 5) {
        this.location.listType = this.location.TYPE_INVS
        this.location.selectedId = u[5] > 0 ? parseInt(u[5]) : null
      }
      console.log('location is ', this.location)
    },

    setListDataSummary(summary) {
      this.listDataSummary = summary
      // console.log('ZZZZZZ listDataSummary:', summary)
    },

    setDataSiteNames(data) {
      this.siteNames = {}
      data.items.forEach((item) => {
        this.siteNames[item.id] = { 'name': item.name, 'tz': item.timezone }
      })

      // update location with the tz in case it wasn't there yet
      if (this.location.siteId && this.location.siteId in this.siteNames) {
        this.location.siteTz = this.siteNames[this.location.siteId]['tz']
      }
    },
    setDataGatewayNames(data) {
      this.gwNames = {}
      data.items.forEach((item) => {
        this.gwNames[item.serial] = item.name
      })
    },

    // // *** search ***

    globalSearch() {
      this.showSearchDialog = true
    },

    closeSearch() {
      this.showSearchDialog = false
    },
  },
}
</script>

<style lang="scss">
.row-equal .flex {
  .va-card {
    height: 100%;
  }
}
.dashboard {
  .va-card {
    margin-bottom: 0 !important;
  }
}
.va-modal {
  max-width: 90vw;
}.va-modal__inner {
  max-width: 90vw;
}
</style>
